<template>
	<ul v-if="crumbs.length" class="breadcrumb">
		<!--		<li>-->
		<!--			<AppLink :to="{name: 'dashboard'}" class="breadcrumb__back">Back</AppLink>-->
		<!--		</li>-->
		<li>
			<AppLink :to="{name: 'dashboard'}">Dashboard</AppLink>
		</li>
		<li v-for="(parentRoute, routeIndex) in crumbs" :key="routeIndex">
			<AppLink
				v-if="parentRoute.path !== $route.path" :to="parentRoute"
				v-html="parentRoute.meta.name"/>
			<span v-else v-html="parentRoute.meta.name"></span>
		</li>
	</ul>
</template>
<script>
export default {
	computed: {
		routes() {
			return this.$router.getRoutes();
		},
		routeParts() {
			return this.$route.path.replace(/^\/+|\/+$/g, "").split("/");
		},
		crumbs() {
			return _.filter(this.routes, route => {
				let routeParts = route.path.replace(/^\/+|\/+$/g, "").split("/");
				return !routeParts.length || (routeParts[0] === this.routeParts[0] && routeParts.length < this.routeParts.length) || route.path === this.$route.path;
			}).reverse();
		},
	},
};
</script>
